// import TripDetailsForm from "../pages/TripDetailsForm";
import axios from "./axiosInstance";

const TripDetailsFormAPI = {
  postTripDetailsForm: (payload) => axios.post("customenquiry", payload),
};

export default TripDetailsFormAPI;